import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { OC_API_URL } from '@/shared/constants/linksApi.js'

// Лучше вынести в переменные окружения (.env.local)
const API_USER = process.env.API_USER || 'testuser'
const API_PASS = process.env.API_PASS || 'testbtpeel748'

// Собираем строку авторизации
const basicAuth =
  'Basic ' + Buffer.from(`${API_USER}:${API_PASS}`).toString('base64')

export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery: fetchBaseQuery({
    baseUrl: OC_API_URL,
    prepareHeaders: (headers) => {
      headers.set('Authorization', basicAuth)
      headers.set('Content-Type', 'application/json') // можно убрать, если бекенд сам ставит
      return headers
    },
  }),
  endpoints: (builder) => ({
    sess: builder.query({
      query: () => 'api/sess',
    }),
    signUp: builder.mutation({
      query: (body) => ({
        url: '/api/customer/registration',
        method: 'POST',
        body,
      }),
    }),
    signIn: builder.mutation({
      query: (body) => ({
        url: '/api/customer/authentication',
        method: 'POST',
        body,
      }),
    }),
    signInTg: builder.mutation({
      query: (body) => ({
        url: '/api/customer/authenticationTg',
        method: 'POST',
        body,
      }),
    }),
    signInVk: builder.mutation({
      query: (body) => ({
        url: '/api/customer/authenticationVk',
        method: 'POST',
        body,
      }),
    }),
    logout: builder.mutation({
      query: (body) => ({
        url: '/api/customer/logout',
        method: 'POST',
        body,
      }),
    }),
    checkUser: builder.mutation({
      query: (userInfo) => ({
        url: '/api/customer/getCustomerInfo',
        method: 'POST',
        body: userInfo,
      }),
    }),
    recoveryRequest: builder.mutation({
      query: (body) => ({
        url: 'api/customer/passwordRecoveryRequest',
        method: 'POST',
        body,
      }),
    }),
    recoveryChange: builder.mutation({
      query: (body) => ({
        url: 'api/customer/passwordRecoveryChange',
        method: 'POST',
        body,
      }),
    }),
    isAdmin: builder.query({
      query: () => 'api/customer/isAdmin',
    }),
  }),
})
